import UpdateSavedQueryModal from './UpdateSavedQueryModal';

export default UpdateSavedQueryModal;
